import { Form, Tab, Tabs, Row, Col, Card, InputGroup } from "react-bootstrap"
import ReactDatePicker from "react-datepicker"
import PortalService from '../../../services/portal.service';
import { useContext, useEffect, useState } from "react";
import StateContext from "../../../context/State";
import { defaultMortgageInformation } from "../../../data";
import { FileInfoModel, MortgageInformationModel } from "../../../types";



const MortgageInfo = () => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);

    const [saleFile, setSaleFile] = useState<boolean>(false);
    const [mortgageInformation, setMortgageInformation] = useState<MortgageInformationModel>(defaultMortgageInformation);
    // todo: types - date|string won't work w/ ui element
    const [firstPaymentDatePrimary, setFirstPaymentDatePrimary] = useState<any>('');
    const [lastPaymentDatePrimary, setLastPaymentDatePrimary] = useState<any>('');
    const [firstPaymentDateSecondary, setFirstPaymentDateSecondary] = useState<any>('');
    const [lastPaymentDateSecondary, setLastPaymentDateSecondary] = useState<any>('');

    
    useEffect(() => {
        setFirstPaymentDatePrimary(mortgageInformation.primaryMortgage.firstPaymentDate ? new Date(mortgageInformation.primaryMortgage.firstPaymentDate) : '');
        setLastPaymentDatePrimary(mortgageInformation.primaryMortgage.lastPaymentDate ? new Date(mortgageInformation.primaryMortgage.lastPaymentDate) : '')
        setFirstPaymentDateSecondary(mortgageInformation.secondaryMortgage.firstPaymentDate ? new Date(mortgageInformation.secondaryMortgage.firstPaymentDate) : '')
        setLastPaymentDateSecondary(mortgageInformation.secondaryMortgage.lastPaymentDate ? new Date(mortgageInformation.secondaryMortgage.lastPaymentDate) : '')
    }, [mortgageInformation])


    // eslint-disable-next-line
    useEffect(() => { getMortgageInfo(); getFileType(); }, []);

    const getMortgageInfo = async () => {
        try {
            const mortgageResponse: MortgageInformationModel = await portalService.getMortgageInfo(state.portalId);
            if (mortgageResponse.primaryMortgage || mortgageResponse.secondaryMortgage) {
                setMortgageInformation(mortgageResponse);
            }
        } catch (e) {
            console.log('unable to retrieve mortgage info: ', e)
        }
    }

    const getFileType = async () => {
        try {
            const fileTypeResponse: FileInfoModel = await portalService.getFileInfo(state.appId);
            if (fileTypeResponse) {
                if (fileTypeResponse.file.sellers.length !== 0) {
                    setSaleFile(true);
                }
            }
        } catch (e) {
            console.log('unable to get file type', e)
        }
    }

    return (
        <>
            {
                !saleFile &&

                <Card>
                    <Card.Header>
                        <Card.Title>Mortgage Information</Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <Tabs defaultActiveKey="primaryMortgage">
                            <Tab eventKey="primaryMortgage" title="Primary Mortgage">
                                <Row className="mb-5"></Row>
                                <Row className="mb-5">
                                    <Col className="col-8">
                                        <Form.Label>Mortgage Lender</Form.Label>
                                        <Form.Control
                                            name='mortgageLender'
                                            readOnly
                                            placeholder="Not submitted"
                                            value={mortgageInformation.primaryMortgage.mortgageLender}
                                        />
                                    </Col>

                                    <Col>
                                        <Form.Label>Mortgage Amount</Form.Label>
                                        <Form.Control
                                            name='mortgageAmount'
                                            type="number"
                                            placeholder="Not submitted"
                                            value={Number.isNaN(parseInt(mortgageInformation.primaryMortgage.mortgageAmount)) ? '' : parseInt(mortgageInformation.primaryMortgage.mortgageAmount)}
                                            readOnly
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-5">
                                    <Col>
                                        <Form.Label>First Payment Date</Form.Label>
                                        <InputGroup className="datePickerWrapper read-only">
                                            <InputGroup.Text onClick={(e) => {
                                                e.currentTarget.nextElementSibling.getElementsByTagName("input")[0].dispatchEvent(new Event("click", {
                                                    bubbles: true,
                                                    cancelable: true,
                                                }));
                                            }} >
                                                <i className="fa-light fa-calendar-days"
                                                    />
                                            </InputGroup.Text>
                                            <div className="form-control read-only">
                                                <ReactDatePicker
                                                    dateFormat='MMM/dd/yyyy'
                                                    selected={firstPaymentDatePrimary}
                                                    placeholderText={firstPaymentDatePrimary ? '' : 'Not Submitted'}
                                                    readOnly
                                                    onChange={(d) => { }}
                                                />
                                            </div>
                                        </InputGroup>
                                    </Col>

                                    <Col>
                                        <Form.Label>Last Payment Date</Form.Label>
                                        <InputGroup className="datePickerWrapper read-only">
                                            <InputGroup.Text onClick={(e) => {
                                                e.currentTarget.nextElementSibling.getElementsByTagName("input")[0].dispatchEvent(new Event("click", {
                                                    bubbles: true,
                                                    cancelable: true,
                                                }));
                                            }} >
                                                <i className="fa-light fa-calendar-days"
                                                    />
                                            </InputGroup.Text>
                                            <div className="form-control read-only">
                                                <ReactDatePicker
                                                    dateFormat='MMM/dd/yyyy'
                                                    selected={lastPaymentDatePrimary}
                                                    showYearDropdown
                                                    placeholderText={lastPaymentDatePrimary ? '' : 'Not Submitted'}
                                                    readOnly
                                                    onChange={(d) => { }}
                                                />
                                            </div>
                                        </InputGroup>
                                    </Col>

                                    <Col>
                                    </Col>
                                </Row>

                                <h3>Contact Information</h3>

                                <Row>
                                    <Col>
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control
                                            name='lenderContactName'
                                            readOnly
                                            placeholder="Not submitted"
                                            value={mortgageInformation.primaryMortgage.lenderContactName}
                                        />
                                    </Col>

                                    <Col>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            name='lenderContactEmail'
                                            readOnly
                                            placeholder="Not submitted"
                                            value={mortgageInformation.primaryMortgage.lenderContactEmail}
                                        />
                                    </Col>

                                    <Col>
                                        <Form.Label>Phone</Form.Label>
                                        <Form.Control
                                            name='lenderContactPhone'
                                            readOnly
                                            placeholder="Not submitted"
                                            value={mortgageInformation.primaryMortgage.lenderContactPhone}
                                        />
                                    </Col>
                                </Row>
                            </Tab>

                            <Tab eventKey="secondaryMortgage" title="Secondary Mortgage">
                                <Row className="mb-5"></Row>
                                <Row className="mb-5">
                                    <Col className="col-8">
                                        <Form.Label>Mortgage Amount</Form.Label>
                                        <Form.Control
                                            name='mortgageAmount'
                                            type="number"
                                            placeholder="Not submitted"
                                            value={Number.isNaN(parseInt(mortgageInformation.secondaryMortgage.mortgageAmount)) ? '' : parseInt(mortgageInformation.secondaryMortgage.mortgageAmount)}
                                            readOnly
                                        />
                                    </Col>

                                    <Col>
                                        <Form.Label>Mortgage Lender</Form.Label>
                                        <Form.Control
                                            name='mortgageLender'
                                            placeholder="Not submitted"
                                            value={mortgageInformation.secondaryMortgage.mortgageLender}
                                            readOnly
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-5">
                                    <Col>
                                        <Form.Label>First Payment Date</Form.Label>
                                        <InputGroup className="datePickerWrapper read-only">
                                            <InputGroup.Text onClick={(e) => {
                                                e.currentTarget.nextElementSibling.getElementsByTagName("input")[0].dispatchEvent(new Event("click", {
                                                    bubbles: true,
                                                    cancelable: true,
                                                }));
                                            }} >
                                                <i className="fa-light fa-calendar-days"
                                                    />
                                            </InputGroup.Text>
                                            <div className="form-control read-only">
                                                <ReactDatePicker
                                                    dateFormat='MMM/dd/yyyy'
                                                    selected={firstPaymentDateSecondary}
                                                    placeholderText={firstPaymentDateSecondary ? '' : 'Not Submitted'}
                                                    showYearDropdown
                                                    onChange={(d) => { }}
                                                    readOnly
                                                />
                                            </div>
                                        </InputGroup>
                                    </Col>

                                    <Col>
                                        <Form.Label>Last Payment Date</Form.Label>
                                        <InputGroup className="datePickerWrapper read-only">
                                            <InputGroup.Text onClick={(e) => {
                                                e.currentTarget.nextElementSibling.getElementsByTagName("input")[0].dispatchEvent(new Event("click", {
                                                    bubbles: true,
                                                    cancelable: true,
                                                }));
                                            }} >
                                                <i className="fa-light fa-calendar-days"
                                                    />
                                            </InputGroup.Text>
                                            <div className="form-control read-only">
                                                <ReactDatePicker
                                                    dateFormat='MMM/dd/yyyy'
                                                    selected={lastPaymentDateSecondary}
                                                    placeholderText={lastPaymentDateSecondary ? '' : 'Not Submitted'}
                                                    showYearDropdown
                                                    onChange={(d) => { }}
                                                    readOnly
                                                />
                                            </div>
                                        </InputGroup>
                                    </Col>

                                    <Col>
                                    </Col>
                                </Row>

                                <h3>Contact Information</h3>

                                <Row>
                                    <Col>
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control
                                            name='lenderContactName'
                                            value={mortgageInformation.secondaryMortgage.lenderContactName}
                                            readOnly
                                            placeholder="Not submitted"
                                        />
                                    </Col>

                                    <Col>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            name='lenderContactEmail'
                                            value={mortgageInformation.secondaryMortgage.lenderContactEmail}
                                            readOnly
                                            placeholder="Not submitted"
                                        />
                                    </Col>

                                    <Col>
                                        <Form.Label>Phone</Form.Label>
                                        <Form.Control
                                            name='lenderContactPhone'
                                            value={mortgageInformation.secondaryMortgage.lenderContactPhone}
                                            readOnly
                                            placeholder="Not submitted"
                                        />
                                    </Col>
                                </Row>
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            }
        </>
    )
}

export default MortgageInfo;
